export default "__VITE_ASSET__Btxb3lmJ__"